import { useMutation, useQueryClient } from "@tanstack/react-query";
import { siteWizardQuery } from "../../../../../../hooks/useSiteWizard";
import urls from "../../../../../../urls";
import { useUploadVollmacht } from "./useUploadVollmacht";
import { vollmachtMsbFilesQueries } from "./useVollmachtMsbFiles";

function useUploadVollmachtMsb(siteId: number) {
  const { uploadVollmacht } = useUploadVollmacht(siteId, {
    uploadUrl: urls.api.uploadMsbVollmachtFile
  });
  const queryClient = useQueryClient();

  const uploadVollmachtMsbMutation = useMutation({
    mutationFn: ({ files }: { files: File[] }) => uploadVollmacht(files),
    onSettled() {
      queryClient.invalidateQueries(vollmachtMsbFilesQueries.bySiteId(siteId));
      queryClient.invalidateQueries(siteWizardQuery(siteId));
    }
  });

  return { uploadVollmachtMsbMutation };
}

export { useUploadVollmachtMsb };
